<script>
  export let width = 18;
  export let height = 9;
  export let customColor = null;
  export let strokeWidth = '1.5';

  export let size = null;

  $: if (size) {
    width = size;
    height = size;
  }
</script>

<svg
  {width}
  {height}
  viewBox="0 0 18 9"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M16.9201 0.949951L10.4001 7.46995C9.63008 8.23995 8.37008 8.23995 7.60008 7.46995L1.08008 0.949951"
    class={$$props.class || 'stroke-garden-grey-600'}
    stroke={customColor}
    stroke-width={strokeWidth}
    stroke-miterlimit="10"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
